import * as actionTypes from '../Register_action.types';

const initialState = {
    loggingIn: false,
    salaryRegisters: [],
    error: null,
    message: '',
}
const SalaryReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_SALARY_REGISTER_REQUEST:
        case actionTypes.UPLOAD_SALARY_REGISTER_REQUEST:
        case actionTypes.UPDATE_SALARY_REGISTER_REQUEST:
        case actionTypes.DELETE_SALARY_REGISTER_REQUEST:
        case actionTypes.MULTI_DELETE_SALARY_REGISTER_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case actionTypes.GET_SALARY_REGISTER_SUCCESS:
            return {
                ...state,
                loading: false,
                salaryRegisters: action.payload
            }
        case actionTypes.UPLOAD_SALARY_REGISTER_SUCCESS:
        case actionTypes.UPDATE_SALARY_REGISTER_SUCCESS:
        case actionTypes.DELETE_SALARY_REGISTER_SUCCESS:
        case actionTypes.MULTI_DELETE_SALARY_REGISTER_SUCCESS:
            return {
                ...state,
                loading: false,
                message: action.payload,
            }
        case actionTypes.GET_SALARY_REGISTER_FAILURE:
        case actionTypes.UPLOAD_SALARY_REGISTER_FAILURE:
        case actionTypes.UPDATE_SALARY_REGISTER_FAILURE:
        case actionTypes.DELETE_SALARY_REGISTER_FAILURE:
        case actionTypes.MULTI_DELETE_SALARY_REGISTER_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            }
        default:
            return state;
    }
}
export default SalaryReducer;
